import { combineReducers, concatReducers } from "redux-mvc";
import optimist from "redux-optimist";
import { routerReducer } from "react-router-redux";
import { flopflipReducer, FLOPFLIP_STATE_SLICE } from "@flopflip/react-redux";

import { history } from "./history";
import errors from "./errors/reducer";

import accountProfile from "./accounts/profile/reducer";

import organization from "./organization/reducer";

import event from "./event/reducer";
import eventEmailMergeTags from "./event/email-merge-tags/reducer";
import events from "./events/reducer";

import eventEmailTemplates from "./eventEmailTemplates/reducer";

import portal from "./portal/reducer";

import moduleModule from "./modules/module/reducer";
import moduleModules from "./modules/modules/reducer";
import moduleMessages from "./modules/messages/reducer";
import moduleLayouts from "./modules/layouts/reducer";
import moduleLayout from "./modules/layout/reducer";
import moduleLayoutVisibleFields from "./modules/layouts/visibleFields/reducer";
import moduleRecordTypes from "./modules/recordTypes/reducer";
import moduleFields from "./modules/fields/reducer";
import moduleRecords from "./modules/records/reducer";
import recordView from "./modules/record/reducer";

import userPermissionProfile from "./permissions/user-permission-profile/reducer";
import contactAssignedDocumentRequests from "./contacts/assignedDocumentRequests/reducer";

import user from "./user/reducer";
import userAccessLevels from "./user/access-levels/reducer";
import modal from "./modal/reducer";
import snackbar from "./snackbar/reducer";
import entityReferences from "./entityReferences/reducer";
import documents from "./documents/reducer";

import globalModule from "./global";

const reducer = optimist(
  combineReducers({
    [FLOPFLIP_STATE_SLICE]: flopflipReducer,
    contacts: combineReducers({
      assignedDocumentRequests: contactAssignedDocumentRequests
    }),
    documents,
    accounts: combineReducers({
      profile: accountProfile
    }),
    event: combineReducers({
      event,
      emailMergeTags: eventEmailMergeTags
    }),
    events,
    errors,
    eventEmailTemplates,
    modules: combineReducers({
      fields: moduleFields,
      layout: moduleLayout,
      layoutVisibleFields: moduleLayoutVisibleFields,
      layouts: moduleLayouts,
      messages: moduleMessages,
      module: moduleModule,
      modules: moduleModules,
      records: moduleRecords,
      recordTypes: moduleRecordTypes,
      recordView
    }),
    portal,
    permissions: combineReducers({
      userProfile: userPermissionProfile
    }),
    user,
    userAccessLevels,
    modal,
    snackbar,
    entityReferences,
    organization: combineReducers({
      organization
    }),
    history,
    routing: routerReducer
  })
);

export default concatReducers([globalModule.reducer, reducer]);
